/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontFeaturedSection_user$ref = any;
export type StorefrontHome_user$ref = any;
export type StorefrontHome_user = {
    readonly " $fragmentRefs": StorefrontFeaturedSection_user$ref;
    readonly " $refType": StorefrontHome_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontHome_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontFeaturedSection_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'c8f3973dfb191c16a7a06932ffba73d2';
export default node;
